export default __webpack_public_path__ + "static/media/2022 Audited Financial Statement (GHSI).2b5b019d.pdf";